// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__35Sbr","productName":"Table_productName__1zazN"};